import { performFetchRequest } from './common';
import type { RoundTripSerialized } from '../TypeUtils';

export interface ConsolationPrizeRow {
  id: string;
  created_at: Date;
  last_modified: Date;
  player_id: string;
  value: number;
  claimed: boolean;
  giftcloud_reward_id: string | null;
  // Newer columns
  awarded_at: Date | null;
  prize_state: 'IN_PROGRESS' | 'COMPLETE' | null;
  prize_code: string;
}

export interface SpinToWinStatusResponse {
  tokenInfo: ConsolationPrizeRow,
  playerFirstName: string;
  expired: boolean;
}

export interface SpinToWinSpinResponse {
  tokenInfo: ConsolationPrizeRow,
  alreadySpun: boolean;
  expired: boolean;
}

export interface ErrorResponse {
  reason: string;
}


export const fetchSpinToWinStatusByToken = async (token: string): Promise<RoundTripSerialized<SpinToWinStatusResponse|ErrorResponse>> => {
  return await performFetchRequest(`/spin-to-win/status?token=${token}`, {});
};

export const fetchStartSpinToWinForToken = async (token: string): Promise<RoundTripSerialized<SpinToWinSpinResponse|ErrorResponse>> => {
  return await performFetchRequest(
    `/spin-to-win/spin`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: token })
    });
};
